import React,{ useEffect,useState } from 'react';

import { DatePicker } from 'react-responsive-datepicker'
import 'react-responsive-datepicker/dist/index.css'
import moment from "moment";
import Moment from 'react-moment';
function Options({ updateChart}) {
  
  const [fromDateisOpen,setFromDateIsOpen]=useState(false)
  const [filterSelected, setFilterSelected] = useState("last10")
  const [fromDate,setFromDate]=useState(moment().add(-4, 'M')?._d)
  const [untilDateisOpen,setUntilDateIsOpen]=useState(false)
  const [untilDate,setUntilDate]=useState(new Date())
  useEffect(() => {
    const filterProps= {
      filterSelected: filterSelected,
      fromDate: fromDate,
      untilDate:untilDate
    }
    updateChart(filterProps)
  }, [filterSelected,fromDate,untilDate]);
  
  const updateFromDate = (date) => {
    setFromDate(date)
    setFromDateIsOpen(false)
} 
  const updateUntilDate=(date)=>{
    setUntilDate(date)
    setUntilDateIsOpen(false)
  } 
  

  return (
    <div className='row'>

      להציג:
      <select className='filterSelect' onChange={a=>setFilterSelected(a.target.value)}>
        <option value="last10">10 תוצאות אחרונות</option>
        <option value="lastMonth">מהחודש האחרון</option>
        <option value="betweenDates">בין תאריכים</option>
      </select>

      {" "}
      <div className='row' style={{display:filterSelected==="betweenDates"?"flex":"none"}}>
      
          <p className='date' onClick={() => setFromDateIsOpen(true)}>            
        <Moment date={fromDate} format="DD/MM/YYYY"/>
        </p>
        <p>-</p>
          
          <p className='date'  onClick={() => setUntilDateIsOpen(true)}>            
        <Moment date={untilDate} format="DD/MM/YYYY"/>
          </p>  

   
        
        <DatePicker
          onChange={a=>updateFromDate(a)}
          isOpen={fromDateisOpen}
          dayNames={['א', 'ב', 'ג', 'ד', 'ה', 'ו', 'שבת']}
          monthNames={['ינואר', 'פברואר', 'מרץ', 'אפריל', 'מאי','יוני', 'יולי', 'אוגוסט', 'ספטמבר', 
          'אוקטובר', 'נובמבר', 'דצמבר']}
        onClose={() => setFromDateIsOpen(false)}
        defaultValue={fromDate}
       showTitle={true} 
          closeText='אישור'
          clearText=''
          colorScheme='#f26322'
          title='החל מתאריך:'
        headerFormat='יום DD, dd MM'
        />
        
        <DatePicker
          onChange={a=>updateUntilDate(a)}
          isOpen={untilDateisOpen}
          dayNames={['א', 'ב', 'ג', 'ד', 'ה', 'ו', 'שבת']}
          monthNames={['ינואר', 'פברואר', 'מרץ', 'אפריל', 'מאי','יוני', 'יולי', 'אוגוסט', 'ספטמבר', 
          'אוקטובר', 'נובמבר', 'דצמבר']}
        onClose={() => setUntilDateIsOpen(false)}
        defaultValue={untilDate}
       showTitle={true} 
          closeText='אישור'
          clearText=''
          colorScheme='#f26322'
          title='עד תאריך:'
        headerFormat='יום DD, dd MM'
        />
      </div>
    </div>
  );
}

export default Options;
